import * as AlertBarState from "../../../../components/alert-bar/AlertBar.state";
import { LoginForm } from "@thecb/components";
import * as Nested from "../../../../util/Nested";
import { oktaLoginSuccess } from "../../../../state/reducer";

export const SUBMIT_LOGIN_FORM = "adminLogin/SUBMIT_LOGIN_FORM";
const submitLoginForm = () => ({ type: SUBMIT_LOGIN_FORM });

export const LOGIN_SUCCESS = "adminLogin/LOGIN_SUCCESS";
export const loginSuccess = refreshToken => ({
  type: LOGIN_SUCCESS,
  payload: { refreshToken }
});

const LOGIN_ERROR = "adminLogin/LOGIN_ERROR";
export const loginError = error => ({ type: LOGIN_ERROR, payload: { error } });

const initialState = {
  submitting: false,
  error: false
};

export const _reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUBMIT_LOGIN_FORM:
      return { ...state, submitting: true };
    case LOGIN_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: false
      };
    case LOGIN_ERROR:
      return {
        ...state,
        submitting: false,
        error: payload
      };
    default:
      return state;
  }
};

export const _mapStateToProps = state => ({
  ...state.login,
  auth: state.adminLogin
});
export const _mapDispatchToProps = dispatch => ({
  submitLoginForm: () => dispatch(submitLoginForm()),
  oktaLoginSuccess: accessToken => dispatch(oktaLoginSuccess(accessToken))
});

export const ALERT_BAR_ACTION = "adminLogin/ALERT_BAR_ACTION";
export const loginAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

export const LOGIN_FORM_ACTION = "adminLogin/LOGIN_FORM_ACTION";
export const loginFormAction = Nested.nestedAction(LOGIN_FORM_ACTION);

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
  },
  {
    forms: {
      adminLoginForm: {
        ...LoginForm,
        actionType: LOGIN_FORM_ACTION
      }
    },
    alertBars: {
      adminLoginAlertBar: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION
      }
    }
  },
  "admin"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
